import moment from "moment";


const SQL_DATE_TIME = "YYYY-MM-DD HH:mm:ss";
// Moment accepts 24:00 and overflowing offsets; retain the API's stricter input range.
const OFFSET_DATE_TIME = /^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):?[0-5]\d)$/;

export const formatCheckInPositionDate = (value) => {
    if (typeof value !== "string") return null;

    const text = value.trim();
    const date = moment.utc(text, [ SQL_DATE_TIME, moment.ISO_8601 ], "en", true);

    if (!date.isValid() || date.year() < 1) return null;

    if (date.format(SQL_DATE_TIME) === text)
    {
        // The API's offset-free SQL timestamps already represent German local time.
        return date.format("DD.MM.YYYY HH:mm [(Berlin)]");
    }

    if (!OFFSET_DATE_TIME.test(text)) return null;

    try
    {
        const formatted = new Intl.DateTimeFormat("de-DE", {
            timeZone: "Europe/Berlin",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: "h23",
        }).formatToParts(date.toDate()).reduce((result, part) => ({
            ...result,
            [ part.type ]: part.value,
        }), {});

        return `${ formatted.day }.${ formatted.month }.${ formatted.year.padStart(4, "0") } ${ formatted.hour }:${ formatted.minute } (Berlin)`;
    } catch (error)
    {
        return null;
    }
};
